import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";

// Define an async thunk to fetch data from the API

export const userLoginApi = createAsyncThunk(
  "login/userLoginApi",
  async ({ email, password }, { rejectWithValue }) => {
    // Accept email and password as arguments
    try {
      const response = await axiosInstance.post("/auth/superuserlogin/", {
        // Use POST to send data
        email: email,
        password: password,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const userForgotPasswordApi = createAsyncThunk(
  "login/userForgotPasswordApi",
  async ({ email }, { rejectWithValue }) => {
    // Accept email and password as arguments
    try {
      const response = await axiosInstance.post("/auth/forgotpassword/", {
        // Use POST to send data
        email: email,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const userOtpVerificationApi = createAsyncThunk(
  "login/userOtpVerificationApi",
  async ({ email, otp }, { rejectWithValue }) => {
    // Accept email and password as arguments
    try {
      const response = await axiosInstance.post("/auth/forgotpassword-otp/", {
        // Use POST to send data
        email: email,
        otp: otp,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const userResetPasswordApi = createAsyncThunk(
  "login/userResetPasswordApi",
  async ({ email, new_password }, { rejectWithValue }) => {
    // Accept email and password as arguments
    try {
      const response = await axiosInstance.post("/auth/resetpassword/", {
        // Use POST to send data
        email: email,
        new_password: new_password,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
